/**
 * Cancel & Reschedule Settings Page
 * Cancellation policy text, self-service windows, and late-cancellation threshold.
 */

import { createFileRoute, useParams } from '@tanstack/react-router'
import { Helmet } from 'react-helmet-async'
import { SettingsPageHeader } from '@/components/ui'
import { BusinessSetupPageShell } from './business-setup/components/business-setup-page-shell'
import { CancellationPolicyCard } from './calendar-appointments/components/cancellation-policy-card'
import { CancelRescheduleWindowCard } from './calendar-appointments/components/cancel-reschedule-window-card'
import { LateCancellationsCard } from './calendar-appointments/components/late-cancellations-card'
import { formatDocumentTitle } from '@/lib/document-title'

export const Route = createFileRoute('/_auth/$orgId/settings/calendar-appointments/cancel-reschedule')({
  component: CancelReschedulePage,
})

function CancelReschedulePage() {
  const { orgId } = useParams({
    from: '/_auth/$orgId/settings/calendar-appointments/cancel-reschedule',
  })

  return (
    <>
      <Helmet defer={false}>
        <title>{formatDocumentTitle('Cancel & Reschedule', 'Calendar & Appointments')}</title>
      </Helmet>

      <BusinessSetupPageShell orgId={orgId} activePath="cancel-reschedule">
        <SettingsPageHeader
          title="Cancel & Reschedule"
          description="Set your cancellation policy and how clients can cancel or reschedule their own appointments."
        />

        <div className="space-y-6 max-w-2xl">
          <CancellationPolicyCard />
          <CancelRescheduleWindowCard />
          <LateCancellationsCard />
        </div>
      </BusinessSetupPageShell>
    </>
  )
}
